// extracted by mini-css-extract-plugin
export default {"root":"UGC_root__23hQq","title":"UGC_title__3OkfZ"};